import React from "react";
import "../../assets/css/home.css";
import { motion } from "framer-motion";
import { NavLink } from "react-router-dom";

export default function Home() {
  return (
    <section className="home">

      {/* Background Shapes */}
      <div className="bg-circle one"></div>
      <div className="bg-circle two"></div>

      <div className="home-container">

        {/* Left Content */}
        <div className="home-text">

          <motion.h4
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.2 }}
          >
            Welcome to Trip Word
          </motion.h4>

          <motion.h1
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.3 }}
          >
            Your Journey, <span>Our Responsibility</span>
          </motion.h1>

          <motion.p
            initial={{ opacity: 0, y: 40 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.4 }}
          >
            Trip Word is a fast-growing travel and event management agency, started in 2023,
            dedicated to creating unforgettable travel experiences for groups, families,
            corporates, and adventure seekers.
            <br /><br />
            From planning your itinerary to booking flights, hotels, and organizing events —
            we handle everything so you can enjoy your journey stress-free.
          </motion.p>

        {/* import { NavLink } from "react-router-dom"; */}

<motion.div
  className="home-buttons"
  initial={{ opacity: 0 }}
  animate={{ opacity: 1 }}
  transition={{ delay: 0.5 }}
>
  <NavLink  to="/services"  className="explore-btn"  style={{ textDecoration: "none" }}>
    Explore Tours
  </NavLink>


   <a 
    href="tel:+91 9699581519" 
    className=" contact-btn"
    style={{ textDecoration: "none" }}
  >
    Call Now 📞
  </a>
</motion.div>

        </div>

        {/* Right Image */}
        <motion.div 
          className="home-image"
          whileHover={{ scale: 1.05, rotate: 1 }}
        >
          <img src="https://images.unsplash.com/photo-1507525428034-b723cf961d3e" alt="travel" />
        </motion.div>

      </div>

    </section>
  );
}